<div class="credit-card-add-wrapper">
  <mat-error *ngIf="stripeNotLoaded">
    We're having trouble communicating with Stripe for credit card handling. Please refresh your browser to continue.
  </mat-error>

  <sonder-success-error-banner *ngIf="errorBanner" [isSuccess]="false" [message]="errorBanner"></sonder-success-error-banner>

  <sonder-success-error-banner *ngIf="cardErrorMessage" class="card-error" role="alert" [message]="cardErrorMessage"></sonder-success-error-banner>

  <form
    [formGroup]="ccForm"
    method="post"
    class="stripe-card-form"
  >
    <sonder-form-body>
      <ng-container *ngIf="useInline && isProposeATime">
        <iris-form-field
          [fxFlex]="useInSessionRequest ? '100%' : '60%'"
          fxFlex.lt-md="100%"
          label="Name on Card"
          data-test="payment-add-card-name-on-card-header-text"
        >
          <iris-text-input
            name="name"
            formControlName="name"
            [placeholder]="isProposeATime ? 'First M. Last' : ''"
            data-test="field-card-name"
          ></iris-text-input>
        </iris-form-field>
      </ng-container>
      <sonder-form-field
        class="credit-card-input"
        [fxFlex]="useInSessionRequest ? '100%' : '50%'"
        fxFlex.lt-md="100%"
        label="Card Number *"
        [overrideLabelCase]="true"
        data-test="payment-add-card-card-number-header-text"
      >
        <div id="stripe-card-number-element"></div>
      </sonder-form-field>
      <sonder-form-field
        [fxFlex]="useInSessionRequest ? '100%' : '20%'"
        fxFlex.lt-md="100%"
        label="CVV *"
        [overrideLabelCase]="true"
        data-test="payment-add-card-cvv-header-text"
      >
        <div id="stripe-card-cvc-element"></div>
      </sonder-form-field>
      <sonder-form-field
        [fxFlex]="useInSessionRequest ? '100%' : '30%'"
        fxFlex.lt-md="100%"
        label="Expiration *"
        data-test="payment-add-card-expiration-header-text"
      >
        <div id="stripe-card-exp-element"></div>
      </sonder-form-field>
      <sonder-form-field
        [fxFlex]="useInSessionRequest ? '100%' : '40%'"
        fxFlex.lt-md="100%"
        label="Billing ZIP Code *"
        [overrideLabelCase]="true"
        data-test="payment-add-card-zipcode-header-text"
      >
        <div id="stripe-card-zip-element"></div>
      </sonder-form-field>

      <ng-container *ngIf="!useInline || !isProposeATime">
        <iris-form-field
          [fxFlex]="useInSessionRequest ? '100%' : '60%'"
          fxFlex.lt-md="100%"
          label="Name on Card"
          data-test="payment-add-card-name-on-card-header-text"
        >
          <iris-text-input
            name="name"
            formControlName="name"
            data-test="field-card-name"
          ></iris-text-input>
        </iris-form-field>
      </ng-container>

      <iris-form-field
        *ngIf="!useInline"
        fxFlex="100%"
        label="Card Nickname"
        data-test="payment-add-card-card-nickname-header-text"
        [showOptionalTag]="false"
      >
        <iris-text-input
          name="nickname"
          formControlName="nickname"
          data-test="field-card-nickname"
        ></iris-text-input>
      </iris-form-field>
    </sonder-form-body>

    <iris-button-container *ngIf="!useInline">
      <iris-button
        [type]="IrisButtonTypes.PRIMARY"
        [typeAttribute]="IrisButtonTypeAttributeOptions.SUBMIT"
        id="pendo-credit-card-save"
        data-test="button-save"
        [disabled]="submitting || !getStripeFormValidity()"
      >
        Save
      </iris-button>
    </iris-button-container>
  </form>

</div>
